import config from '@at/design-system-tokens/dist/config.json';
export var ThemeType;
(function (ThemeType) {
    ThemeType["DEFAULT"] = "DEFAULT";
    ThemeType["COMFORT"] = "COMFORT";
    ThemeType["DARKMODE"] = "DARKMODE";
})(ThemeType || (ThemeType = {}));
export var atdsTheme = config;
